import { createAction, createReducer } from '@reduxjs/toolkit';
import { treatApiResponse } from './functions';
import { IAction } from './interface/apiInterface';
import { IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  type: '',
  report: [
    {
      accountDebited: '',
      description: '',
      accountTypeDebited: '',
      agencyDebited: 0,
      bankIdDebited: '',
      createdAt: '',
      creditedBankId: '',
      customerCnpjCpfDebited: '',
      customerNameDebited: '',
      id: 0,
      jdCabineProtocolNumber: '',
      legalEntityDebited: '',
      messageCode: '',
      partnerId: 0,
      transactionDate: '',
      transactionProtocolNumber: '',
      transactionStatus: '',
      updatedAt: '',
      value: '',
      accountCredited: '',
      accountTypeCredited: '',
      agencyCredited: '',
      customerCnpjCpfCredited: '',
      customerIdDebited: 0,
      customerNameCredited: '',
      legalEntityCredited: '',
    },
  ],
};

export const getAnaliticDataFromApi = createAction(
  '@accountingApp/analiticData/GET_ANALITIC_DATA_FROM_API'
);

export const gotAnaliticDataFromApi = createAction<any>(
  '@accountingApp/analiticData/GOT_ANALITIC_DATA_FROM_API'
);

export const gotErrorFromAnaliticDataApi = createAction(
  '@accountingApp/analiticData/GOT_ERROR_FROM_ANALITIC_DATA_API'
);

const analiticDataReducer = createReducer(INITIAL_STATE, {
  [getAnaliticDataFromApi.type]: (state) => ({
    ...state,
    gotSuccess: false,
    gotError: false,
    isLoading: true,
  }),
  [gotAnaliticDataFromApi.type]: (state, action: IAction) => ({
    ...state,
    gotSuccess: true,
    isLoading: false,
    gotError: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    type: action.payload.tipo,
    report: treatApiResponse(
      action.payload.relatorio[0],
      action.payload.prioridade_de_pesquisa
    ),
  }),
  [gotErrorFromAnaliticDataApi.type]: (state) => ({
    ...state,
    gotSuccess: false,
    isLoading: false,
    gotError: true,
  }),
});

export default analiticDataReducer;
